import { Component } from "@angular/core"
import { NotificationsService } from "angular2-notifications"
import { UserService } from "../../../services/user.service"
import { EduComponent } from "../../../utils/eduComponent"
import Utils from "../../../utils/utils"

@Component({
    selector: "app-student-assignments",
    templateUrl: "./student-assignments.component.html",
    styleUrls: ["./student-assignments.component.less"],
})
export class StudentAssignmentsComponent extends EduComponent {
    public assignmentcode: string = ""
    public hasError = false
    public populationComplete = false
    public defaultLimit = 5
    public displayableAssignments = []
    public assignments = []
    public activeAssignments = []
    public activityTypes = {
        lessonBuilder: 0,
        storyboardAssignment: 1,
        standalonePuzzle: 2,
        standaloneQuiz: 3,
    }
    public checkSignURL = require("../../../../assets/student/check.svg").default

    constructor(
        private userService: UserService,
        private notificationService: NotificationsService
    ) {
        super()
        this.addSub(
            this.userService.assignments.subscribe((assignments: any) => {
                this.assignments = assignments.slice()
                this.assignments.sort((assignment1, assignment2) =>
                    assignment1.date_created > assignment2.date_created ? -1 : 1
                )
                this.displayableAssignments = this.assignments.slice(0, this.defaultLimit)
                this.populationComplete = true
            })
        )
    }

    public isActive(code) {
        return this.activeAssignments.indexOf(code) > -1
    }

    public toggleActive(code) {
        const index = this.activeAssignments.indexOf(code)
        if (index > -1) {
            this.activeAssignments.splice(index, 1)
        } else {
            this.activeAssignments.push(code)
        }
    }

    public isPosterAssignment(assignment) {
        return assignment.activity.type === this.activityTypes.storyboardAssignment
    }

    public isPuzzleAssignment(assignment) {
        return assignment.activity.type === this.activityTypes.standalonePuzzle
    }

    public isQuizAssignment(assignment) {
        return assignment.activity.type === this.activityTypes.standaloneQuiz
    }

    public isLesson(assignment) {
        return (
            !this.isPosterAssignment(assignment) &&
            !this.isPuzzleAssignment(assignment) &&
            !this.isQuizAssignment(assignment)
        )
    }

    public isIlp(assignment) {
        return assignment.activity.is_ilp
    }

    public shouldPaginate() {
        if (this.defaultLimit != null) {
            return this.assignments.length > this.defaultLimit
        }
    }

    public showMore() {
        this.defaultLimit += 5
        this.displayableAssignments = this.assignments.slice(0, this.defaultLimit)
        if (this.defaultLimit > this.assignments.length / 2) {
            this.userService.loadMoreAssignments()
        }
    }

    public submitAssignmentsForm($event) {
        $event.preventDefault()
        this.userService.validateCode(this.assignmentcode).subscribe((data: any) => {
            if (data.url && data.url.length > 0) {
                window.location.href = data.url
            } else if (data.error) {
                this.notificationService.error("", data.error, Utils.alertConfiguration)
            }
        })
    }

    public startAssignment(assignment) {
        if (!this.userService.isStudent()) {
            const teacherResourceURI = assignment.activity.teacher_resource_uri
            const activityCreatorPk = teacherResourceURI.substring(
                13,
                teacherResourceURI.lastIndexOf("/")
            )
            if (Number.parseInt(activityCreatorPk) === this.userService.getUserPK()) {
                return (window.location.href =
                    window.location.origin + assignment.activity.preview_url)
            }
        }
        const updateObj = {
            status: "started",
            student_name: " ",
        }

        this.userService.updateResult(assignment.id, updateObj).subscribe(
            (data: any) => {
                if (data.data && data.data.location) {
                    window.location.href = data.data.location
                } else {
                    window.location.href = assignment.student_result_url
                }
            },
            (error) => {
                let message =
                    "An error occurred while starting the assignment. Please refresh and try again!"
                if (error.error && error.error.result && error.error.result.status) {
                    message = error.error.result.status
                }
                this.notificationService.error("Uh oh!", message, Utils.alertConfiguration)
            }
        )
    }
}
